import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import PrimaryPinkButton from './primary-pink-button'
import './header.css'

const Header = (props) => {
  const [isVisible, setIsVisible] = useState(false)
  return (
    <div data-role="Header" className="header-header">
      <nav className="header-nav">
        <div className="header-container1">
          <Link to="/" className="header-navlink1 Large">
            BETTER CALL AI
          </Link>
          <div className="header-menu1">
            <a
              href="https://bettercallai.fr/#Product"
              className="header-link1 Large"
            >
              Produit
            </a>
            <a href="https://bettercallai.fr/#UC" className="header-link2">
              Cas d&apos;usage
            </a>
            <a
              href="https://bettercallai.fr/#Pricing"
              className="header-link3 Large"
            >
              Tarifs
            </a>
          </div>
          <div className="header-container2">
            <Link to="/contact" className="header-navlink2">
              <div className="header-container3">
                <PrimaryPinkButton
                  button="Prendre rendez-vous"
                  rootClassName="primary-pink-buttonroot-class-name"
                ></PrimaryPinkButton>
              </div>
            </Link>
            <div data-role="BurgerMenu" className="header-burger-menu">
              <svg
                viewBox="0 0 1024 1024"
                onClick={() => setIsVisible(true)}
                className="header-icon1"
              >
                <path d="M128 256h768v86h-768v-86zM128 554v-84h768v84h-768zM128 768v-86h768v86h-768z"></path>
              </svg>
            </div>
          </div>
        </div>
      </nav>
      {isVisible === true && (
        <div
          id="MobileMenu"
          data-role="MobileMenu"
          className="header-mobile-menu"
        >
          <div className="header-top">
            <Link to="/" className="header-navlink3 Large">
              BETTER CALL AI
            </Link>
            <div data-role="CloseMobileMenu" className="header-close-menu">
              <svg
                viewBox="0 0 1024 1024"
                onClick={() => setIsVisible(false)}
                className="header-icon3"
              >
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="header-mid">
            <div className="header-menu2">
              <a
                href="https://bettercallai.fr/#Product"
                onClick={() => setIsVisible(false)}
                className="header-link4 Large"
              >
                Produit
              </a>
              <a
                href="https://bettercallai.fr/#UC"
                onClick={() => setIsVisible(false)}
                className="header-link5 Large"
              >
                Cas d&apos;usage
              </a>
              <a
                href="https://bettercallai.fr/#Pricing"
                onClick={() => setIsVisible(false)}
                className="header-link6 Large"
              >
                Tarifs
              </a>
            </div>
          </div>
          <div className="header-bot"></div>
        </div>
      )}
    </div>
  )
}

export default Header
